<template>
    <TitleNotas :title="''" @refresh="refresh" @reporte="reporte" @saveAll="saveAll" @undo="undo" @redo="redo" :isSaved="isSaved" />
    <div class="card-ed3" 
        :style="'height:' + altoArg + 'px'">
        <ag-grid-vue class="ag-theme-alpine" style="height:100%;" 
            :rowHeight="28" :columnDefs="columnDefs.value" :rowData="rowData.value" :defaultColDef="defaultColDef"
            rowSelection="multiple" :isRowSelectable="isRowSelectable" :enableRangeSelection="true"
            :enterNavigatesVertically="true"  :enterNavigatesVerticallyAfterEdit="true"
            :suppressRowClickSelection="true" :enableFillHandle="true" :undoRedoCellEditing="true" @cell-value-changed="onCellValueChanged"
            :enableCellChangeFlash="true" :processDataFromClipboard="processDataFromClipboard" @grid-ready="onGridReady">
        </ag-grid-vue>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import { styles } from "@/helper/styles"
import { useActivate } from "@/hooks/useActivate"
import TitleNotas from "@/components/utils/TitleNotas.vue"
import { useElemental } from "@/hooks/useElemental"
import { promedios } from "@/helper/promedios"
import { useStore } from 'vuex'
const props = defineProps({
    help: Object,
    idCursodeMatricula: String,
    fechaActivo: Object,
    subnivel: Number,
})
const altoArg = ref(0)
const emit = defineEmits(['refresh', 'reporte', 'saveAll'])
const { cellStylePromedio } = styles()
const { validarFormato, actividadTrim3,
     processDataFromClipboard, calcTrimestreTresCulitativo } = promedios()
const { quinP, sexP, exa3, pro3 } = useActivate()
const store = useStore()

const { isSaved, rowData, save, conforma, saveCuarto} = useElemental()
const isSub = ref(100)
const columnDefs = reactive({})
//==================GRID =============================

const gridApi = ref(null);
const onGridReady = (params) => {
    gridApi.value = params.api;
};

const opt1 = reactive({
    value: [
       {
            headerName: 'NÓMINA', children:
                [
                    { field: "aux", headerName: 'NÚMERO', minWidth: 45, maxWidth: 45 },
                    { field: "estudiante.fullname", headerName: 'LISTA', minWidth: 260 },
                ]
        },
        {
            headerName: 'ACTIVIDADES INDIVIDUALES', children:
                [
                {
                        field: "notas.e1", headerName: 'Ins1', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP(),
                    },
                    {
                        field: "notas.e2", headerName: 'Ins2', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                    {
                        field: "notas.e3", headerName: 'Ins3', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                    {
                        field: "notas.e4", headerName: 'Ins4', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                ]
        },
        {
            headerName: 'ACTIVIDADES GRUPALES', children:
                [
                {
                        field: "notas.f1", headerName: 'Ins1', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f2", headerName: 'Ins2', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f3", headerName: 'Ins3', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f4", headerName: 'Ins4', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                ]
        },
        {
            headerName: '', children:
                [
                    {
                        field: "total3", headerName: 'PROM',
                        valueGetter: params => {
                            return actividadTrim3(params)
                        },
                        cellStyle: params => {
                            return cellStylePromedio(params);
                        }
                    },
                    {
                        field: "cuaActividad", headerName: 'CU', maxWidth: 120,
                        valueGetter: params => {
                            var pro1 = params.getValue('total3');
                            var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
                            if(test1=='0.00') return 'NE'
                            let num = parseFloat(test1)
                            if(!num||num=='') return ''
                            if (num >= 9 && num <= 10) return 'A'
                            else if (num >= 7 && num <= 8.99) return 'EP'
                            else if (num >= 4.01 && num <= 9.99) return 'I'
                            else if (num <= 4) return 'NE'
                        },
                        cellStyle:{ 'font-weight': '600' }
                    }
                ]
        },
        {
            headerName: 'PROYECTO INTEGRADOR', children:
                [
                   {
                        field: "notas.pry3", headerName: 'PROY', editable: props.fechaActivo.ex3,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: exa3(), cellDataType: 'text'
                    },
                    {
                        field: "cuaProyec", headerName: 'CU', maxWidth: 120,
                        valueGetter: params => {
                            var pro1 = params.getValue('notas.pry3');
                            var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
                            if(test1=='0.00') return 'NE'
                            if(test1=='0') return 'NE'
                            let num = parseFloat(test1)
                            if(!num||num=='') return ''
                            if (num >= 9 && num <= 10) return 'A'
                            else if (num >= 7 && num <= 8.99) return 'EP'
                            else if (num >= 4.01 && num <= 9.99) return 'I'
                            else if (num <= 4) return 'NE'
                        },
                        cellStyle:{ 'font-weight': '600' }
                    },
                    
                    {
                        field: "estado", headerName: 'PROM', maxWidth: 120,
                        valueGetter: params => {
                            let cuaActividad = params.getValue('cuaActividad');
                            let a = cuaActividad ? cuaActividad.toString().replace(",", ".") : ''

                            let cuaProyec = params.getValue('cuaProyec');
                            let b = cuaProyec ? cuaProyec.toString().replace(",", ".") : ''
                            if (a=='A' && b=='A') return 'A'
                            if (a=='A' && b=='EP') return 'A'
                            if (a=='A' && b=='I') return 'EP'

                            if (a=='EP' && b=='A') return 'EP'
                            if (a=='EP' && b=='EP') return 'EP'
                            if (a=='EP' && b=='I') return 'EP'

                            if (a=='I' && b=='A') return 'EP'
                            if (a=='I' && b=='EP') return 'I'
                            if (a=='I' && b=='I') return 'I'

                            if (a=='NE' || b=='NE') return 'NE'
                            return ''
                        },
                        cellStyle: { 'font-weight': '700' }
                    },
                ]
        },
    ],
});
const opt2 = reactive({
    value: [
    {
            headerName: 'NÓMINA', children:
                [
                    { field: "aux", headerName: 'NÚMERO', minWidth: 45, maxWidth: 45 },
                    { field: "estudiante.fullname", headerName: 'LISTA', minWidth: 260 },
                ]
        },
        {
            headerName: 'ACTIVIDADES INDIVIDUALES', children:
                [
                {
                        field: "notas.e1", headerName: 'Ins1', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP(),
                    },
                    {
                        field: "notas.e2", headerName: 'Ins2', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                    {
                        field: "notas.e3", headerName: 'Ins3', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                    {
                        field: "notas.e4", headerName: 'Ins4', editable: props.fechaActivo.p5,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: quinP()
                    },
                ]
        },
        {
            headerName: 'ACTIVIDADES GRUPALES', children:
                [
                {
                        field: "notas.f1", headerName: 'Ins1', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f2", headerName: 'Ins2', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f3", headerName: 'Ins3', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                    {
                        field: "notas.f4", headerName: 'Ins4', editable: props.fechaActivo.p6,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: sexP()
                    },
                ]
        },
        {
            headerName: '', children:
                [
                    {
                        field: "total3", headerName: 'PRO',
                        valueGetter: params => {
                            return actividadTrim3(params)
                        },
                        cellStyle: params => {
                            return cellStylePromedio(params);
                        }
                    },
                    {
                        field: "cuaActividad", headerName: 'CU', maxWidth: 120,
                        valueGetter: params => {
                            var pro1 = params.getValue('total3');
                            var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
                            if(test1=='0.00') return 'NE'
                            let num = parseFloat(test1)
                            if(!num||num=='') return ''
                            if (num >= 9 && num <= 10) return 'A'
                            else if (num >= 7 && num <= 8.99) return 'EP'
                            else if (num >= 4.01 && num <= 9.99) return 'I'
                            else if (num <= 4) return 'NE'
                        },
                        cellStyle:{ 'font-weight': '600' }
                    }
                ]
        },
        {
            headerName: 'PROYECTO - EVALUACION', children:
                [
                    {
                        field: "notas.pry3", headerName: 'PROY', editable: props.fechaActivo.ex3,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: pro3(), cellDataType: 'text'
                    },
                    {
                        field: "cuaProyec", headerName: 'CU', maxWidth: 120,
                        valueGetter: params => {
                            var pro1 = params.getValue('notas.pry3');
                            var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
                            if(test1=='0.00') return 'NE'
                            if(test1=='0') return 'NE'
                            let num = parseFloat(test1)
                            if(!num||num=='') return ''
                            if (num >= 9 && num <= 10) return 'A'
                            else if (num >= 7 && num <= 8.99) return 'EP'
                            else if (num >= 4.01 && num <= 9.99) return 'I'
                            else if (num <= 4) return 'NE'
                        },
                        cellStyle:{ 'font-weight': '600' }
                    },
                    {
                        field: "notas.exa3", headerName: 'EVAL', editable: props.fechaActivo.ex3,
                        valueFormatter: (params) => {
                            return validarFormato(params)
                        },
                        cellStyle: exa3(), cellDataType: 'text'
                    },
                    {
                        field: "cuaEval", headerName: 'CU', maxWidth: 120,
                        valueGetter: params => {
                            var pro1 = params.getValue('notas.exa3');
                            var test1 = pro1 ? pro1.toString().replace(",", ".") : ''
                            if(test1=='0.00') return 'NE'
                            if(test1=='0') return 'NE'
                            let num = parseFloat(test1)
                            if(!num||num=='') return ''
                            if (num >= 9 && num <= 10) return 'A'
                            else if (num >= 7 && num <= 8.99) return 'EP'
                            else if (num >= 4.01 && num <= 9.99) return 'I'
                            else if (num <= 4) return 'NE'
                        },
                        cellStyle:{ 'font-weight': '600' }
                    },
                ]
        },
        {
            headerName: 'PROMEDIO', children:
                [
                    {
                        field: "estado", headerName: 'FIN', maxWidth: 120,
                        valueGetter: params => {
                            let cuaActividad = params.getValue('cuaActividad');
                            let a = cuaActividad ? cuaActividad.toString().replace(",", ".") : ''

                            let cuaProyec = params.getValue('cuaProyec');
                            let b = cuaProyec ? cuaProyec.toString().replace(",", ".") : ''

                            let cuaEval = params.getValue('cuaEval');
                            let c = cuaEval ? cuaEval.toString().replace(",", ".") : ''

                            if (a=='A' && b=='A' && c=='A') return 'A'
                            if (a=='A' && b=='A' && c=='EP') return 'A'
                            if (a=='A' && b=='A' && c=='I') return 'A'
                            if (a=='A' && b=='EP' && c=='A') return 'A'
                            if (a=='A' && b=='EP' && c=='EP') return 'A'
                            if (a=='A' && b=='EP' && c=='I') return 'EP'
                            if (a=='A' && b=='I' && c=='A') return 'EP'
                            if (a=='A' && b=='I' && c=='EP') return 'EP'
                            if (a=='A' && b=='I' && c=='I') return 'EP'

                            if (a=='EP' && b=='A' && c=='A') return 'A'
                            if (a=='EP' && b=='A' && c=='EP') return 'EP'
                            if (a=='EP' && b=='A' && c=='I') return 'EP'
                            if (a=='EP' && b=='EP' && c=='A') return 'EP'
                            if (a=='EP' && b=='EP' && c=='EP') return 'EP'
                            if (a=='EP' && b=='EP' && c=='I') return 'EP'
                            if (a=='EP' && b=='I' && c=='A') return 'EP'
                            if (a=='EP' && b=='I' && c=='EP') return 'EP'
                            if (a=='EP' && b=='I' && c=='I') return 'EP'

                            if (a=='I' && b=='A' && c=='A') return 'EP'
                            if (a=='I' && b=='A' && c=='EP') return 'EP'
                            if (a=='I' && b=='A' && c=='I') return 'EP'
                            if (a=='I' && b=='EP' && c=='A') return 'EP'
                            if (a=='I' && b=='EP' && c=='EP') return 'EP'
                            if (a=='I' && b=='EP' && c=='I') return 'I'
                            if (a=='I' && b=='I' && c=='A') return 'EP'
                            if (a=='I' && b=='I' && c=='EP') return 'I'
                            if (a=='I' && b=='I' && c=='I') return 'I'

                            if (a=='NE' || b=='NE' || c=='NE') return 'NE'
                            return ''
                        },
                        cellStyle: { 'font-weight': '800' }
                    },
                ]
        },
    ],
});
const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1
};
const isRowSelectable = ref(null)
//====================================================
const refresh = () => emit('refresh')
const reporte = () => emit('reporte')
const undo = () => gridApi.value.undoCellEditing();
const redo = () => gridApi.value.redoCellEditing();
const onCellValueChanged = (params) => {
      var undoSize = params.api.getCurrentUndoSize();
      disable('#undoBtn', undoSize < 1);
      var redoSize = params.api.getCurrentRedoSize();
      disable('#redoBtn', redoSize < 1);
}

const saveAll = async () => {
    if(isSub.value==6) await saveCuarto(props.idCursodeMatricula)
    else await save(props.idCursodeMatricula)
    if (conforma.value) refresh()
}

onMounted(() => {
    if (props.help.length == 0) altoArg.value = 450
    else altoArg.value = (props.help.length * 28) + 140
    rowData.value = props.help;
    isSub.value = store.state.items?.curso?.num
    if(isSub.value==6) columnDefs.value = opt2.value
    else columnDefs.value = opt1.value
    disable('#undoBtn',true);
    disable('#redoBtn',true);
})
window.disable = function disable(id, disabled) {
  document.querySelector(id).disabled = disabled;
};
</script>